import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import localeText from "../../../../locale";

const CreateTransactionDialog = ({ visible, onHide, onSubmit, loading, currency, title, subtitle }) => {
  const [amount, setAmount] = useState();
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!visible) {
      setAmount(undefined);
      setDescription("");
    }
  }, [visible]);

  const handleHide = () => {
    if (!loading) onHide();
  };

  const header = title ? (
    <div className="flex flex-column gap-2">
      <div className="text-lg font-medium" style={{ color: "var(--theme-text)" }}>
        {title}
      </div>
      {subtitle && (
        <div className="text-sm font-normal" style={{ color: "var(--theme-text-muted)" }}>
          {subtitle}
        </div>
      )}
    </div>
  ) : (
    localeText("transaction")
  );

  return (
    <Dialog
      header={header}
      visible={visible}
      className="w-30rem m-2 transaction-dialog"
      onHide={handleHide}
      draggable={false}
    >
      <div className="flex flex-column gap-4">
        <div className="flex flex-column gap-2">
          <label className="font-semibold text-sm" style={{ color: "var(--theme-text-muted)" }}>
            {localeText("description") || "Descrição"}
          </label>
          <InputText
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={localeText("description") || "Descrição"}
          />
        </div>

        <div className="flex flex-column gap-2">
          <label className="font-semibold text-sm" style={{ color: "var(--theme-text-muted)" }}>
            {localeText("amount")}
          </label>
          <InputNumber
            value={amount}
            onChange={(e) => setAmount(e.value)}
            min={0}
            mode="currency"
            currency={currency}
            placeholder={currency ? `${currency} 0,00` : "0,00"}
          />
        </div>

        <div className="flex justify-content-end">
          <Button
            label={localeText("create")}
            icon="pi pi-check"
            loading={loading}
            onClick={() => onSubmit({ amount, description })}
            className="border-round-md border-none p-no-outline"
            style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CreateTransactionDialog;
